import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { NotConfigured } from './NotConfigured';
import { isConfigured, loadConfig } from './identity';
import { createAuthClient } from './nativeAuth';
import './styles.css';

const root = createRoot(document.getElementById('root')!);

function Fatal({ message }: { message: string }) {
    return (
        <div className="app">
            <header className="masthead">
                <h1>Lowe&rsquo;s Store Counts</h1>
                <p>Consignment based product</p>
            </header>
            <div className="content">
                <div className="alert alert-error">
                    <h3>Sign-in is unavailable</h3>
                    <p style={{ margin: 0 }}>{message}</p>
                </div>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => window.location.reload()}
                >
                    Try again
                </button>
            </div>
        </div>
    );
}

async function start() {
    const config = await loadConfig();

    // The app is deployable before the CIAM tenant exists. Say so plainly
    // instead of throwing an error nobody can act on.
    if (!isConfigured(config)) {
        root.render(
            <StrictMode>
                <NotConfigured />
            </StrictMode>,
        );
        return;
    }

    try {
        const client = await createAuthClient(config);
        root.render(
            <StrictMode>
                <App
                    client={client}
                    allowedDomains={config.allowedDomains}
                    allowedAddresses={config.allowedAddresses}
                />
            </StrictMode>,
        );
    } catch (err) {
        // Never leave a blank page. If the auth client cannot be built the
        // associate needs to see why, not an empty screen.
        console.error('auth client failed to initialise', err);
        root.render(
            <StrictMode>
                <Fatal
                    message={
                        err instanceof Error
                            ? err.message
                            : 'The sign-in service could not be reached.'
                    }
                />
            </StrictMode>,
        );
    }
}

void start();
